import {asNumber, fireConfetti, fireRequest, formToJSON, getComonRequestMessage, notifyError, tryParseJSON} from "@/modules/utils";
import {Block} from "notiflix";

const verificationListeners = () => {
    const States = {
        LOADING: 'loading',
        FILLING: 'filling',
        SUCCESS: 'success',
        FAILURE: 'failure'
    }

    const view = document.querySelector('[data-view="newsletter-verify"]');
    if (!view) return;

    view.setAttribute('data-state', States.LOADING);

    const found = view.querySelector<HTMLInputElement>('[name="__found__"]')?.value === 'true';

    setTimeout(() => {
        if (!found) view.setAttribute('data-state', States.FAILURE);
        else view.setAttribute('data-state', States.FILLING);
    }, 3000);

    const form = view.querySelector<HTMLFormElement>('.filling__wrapper form');
    form?.addEventListener('submit', (e) => {
        e.preventDefault();

        Block.merge({backgroundColor: 'rgba(255,255,255,0.2)'});

        const uiBlockSelector = '.filling__wrapper';
        const data = formToJSON(form.elements)

        fireRequest(
            form.getAttribute('data-action'),
            data, uiBlockSelector, null,
            async (response) => {
                view.setAttribute('data-state', States.SUCCESS);
                await fireConfetti();
                form.reset();

                setTimeout(() => {
                    const data = response.data;

                    try {
                        window.location.replace(data.redirect)
                    } catch (e) {
                        window.location.assign(data.redirect)
                    }
                }, 3000)
            }
        ).catch((error) => {
            // noinspection JSUnresolvedReference
            notifyError(getComonRequestMessage(true), {asFailure: true});
            console.log(error)
        })

        return false;
    })
}

const subscriptionListeners = () => {

    const VIEWS = {
        modal: '#newsletter__async__view',
        standalone: {
            id: '#newsletter__form',
            class: '.newsletter__form__node'
        }
    }

    const asyncView = $(VIEWS.modal);

    // setNewsletterModalState({rendered: false, subscribed: false}); //Note: for debugging purposes

    window.addEventListener('scroll', () => {
        if (window.scrollY > (window.outerHeight / 2)) {
            if (canRenderNewsletterModalView(30)) {
                if (!asyncView.hasClass('show')) asyncView.modal('show')
            }
        }
    })

    asyncView.on('hidden.bs.modal', () => {
        setTimeout(() => {
            setNewsletterModalState({rendered: true, subscribed: null});
        }, 200)
    })

    document.querySelectorAll<HTMLFormElement>(VIEWS.standalone.class).forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            Block.merge({backgroundColor: 'rgba(255,255,255,0.2)'});

            const inModal = form.closest('.modal');
            const data = formToJSON(form.elements);
            const uiBlockSelector = inModal ? `${VIEWS.modal} .modal-content` : VIEWS.standalone.class;

            fireRequest(
                form.getAttribute('data-action'),
                data, uiBlockSelector, null,
                async (response) => {
                    const dataset = response.data || {};

                    setNewsletterModalState({rendered: true, subscribed: true});
                    if (inModal && asyncView) asyncView.modal('hide');
                    if ('rejoice' in dataset && dataset.rejoice) await fireConfetti(2000);
                    form.reset();
                },
            ).catch((error) => {
                notifyError(getComonRequestMessage(true), {asFailure: true});
                console.log(error)
            })

            return false;
        });
    });
}

export const NEWSLETTER_STORAGE_KEY = 'mn_ls__key' //miabeloya newsletter local storage key

interface NewsletterModalViewState {
    rendered: boolean
    subscribed: boolean
    lastRendering: number
}

export const toNewsletterModalViewState = (input: unknown, throwOnFail: boolean = false): NewsletterModalViewState => {
    if (typeof input !== 'object' || input === null) {
        if (!throwOnFail) return {rendered: false, subscribed: false, lastRendering: 0};
        else throw new Error('Invalid JSON for NewsletterModalViewState');
    }

    const data = input as Record<string, unknown>;

    return {
        rendered: Boolean(data.rendered),
        subscribed: Boolean(data.subscribed),
        lastRendering: asNumber(data.lastRendering)
    }
}

export const getNewsletterModalState = (): NewsletterModalViewState => {
    const state = tryParseJSON(localStorage.getItem(NEWSLETTER_STORAGE_KEY));
    return toNewsletterModalViewState(state, false);
}

export const setNewsletterModalState = ({rendered, subscribed}: { rendered: boolean, subscribed: boolean | null }): NewsletterModalViewState => {
    const isSubscribed = subscribed === null ? getNewsletterModalState().subscribed : subscribed;
    const data: NewsletterModalViewState = {rendered, subscribed: isSubscribed, lastRendering: Date.now()};
    localStorage.setItem(NEWSLETTER_STORAGE_KEY, JSON.stringify(data));
    return data;
}

export const canRenderNewsletterModalView = (timeout: number = 5): boolean => {
    const __now = Date.now();
    const {subscribed, rendered, lastRendering} = getNewsletterModalState();
    const __lastRenderingTime = Math.floor((__now - lastRendering) / 60000);
    if (subscribed) return false;
    return rendered !== true || __lastRenderingTime >= timeout; //in minutes
}


export const initNewsletterListeners = () => {
    verificationListeners();
    subscriptionListeners();
}

export default initNewsletterListeners;
